import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/home/pages/Home'

import { HomeRoutePathsEnum } from './homeRouteConfig.types'

export const HOME_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: HomeRoutePathsEnum.HOME,
  },
]
